export interface User {
  id: string;
  name: string;
  email: string;
  provider: 'password' | 'google';
}

export interface Session {
  user: User;
  /** Epoch ms. */
  expiresAt: number;
}

export class AuthError extends Error {
  readonly code: 'invalid_credentials' | 'email_taken' | 'weak_password' | 'invalid_email';

  constructor(code: AuthError['code'], message: string) {
    super(message);
    this.name = 'AuthError';
    this.code = code;
  }
}
